import { mapActions, mapGetters } from 'vuex';
import purchaseOfferSushi from '@/components/purchase/sushi/purchase-offer-sushi/purchase-offer-sushi';
import { roundToTwo, hasNoPositionInAMarketBesidesLoadedContract } from '@/utils/helpers';
import purchaseExtendedBetslipContractInfo
  from '@/components/purchase/sushi/purchase-extended-betslip-contract-info/purchase-extended-betslip-contract-info.vue';
import smallModal from '@/components/generics/modal/small/small.vue';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import orderBookSushi, { ORDER_BOOK_DISPLAY_MODES } from '@/components/purchase/sushi/order-book-sushi/order-book-sushi.vue';
import marketOwnershipAndOrdersBar from '@/components/market/market-ownership-and-orders-bar/market-ownership-and-orders-bar.vue';

export default {
  mixins: [
    purchaseOfferSushi,
  ],
  components: {
    smallModal,
    purchaseExtendedBetslipContractInfo,
    orderBookSushi,
    marketOwnershipAndOrdersBar,
  },
  props: {
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ORDER_BOOK_DISPLAY_MODES,
      isThrottled: false,
    };
  },
  computed: {
    ...mapGetters('app', ['currentPriceSymbol']),
    dontShowMultiples() {
      return !this.isYesType && hasNoPositionInAMarketBesidesLoadedContract({ market: this.market, contract: this.contract });
    },
    showOwnershipAndOrdersSummary() {
      return this.showOwnershipAndOrdersBar &&
        this.showOrderSlip &&
        !this.isMarketSettled &&
        (this.contractModel.userQuantity > 0 || this.contractModel.userOpenOrders > 0);
    },
    extendedOrderBookKey() {
      const timestamp = this.contractModel.timestamp || '-';
      return `${this.contractModel.contractId}-${timestamp}-${this.tradeSuccess.toString()}-${this.contractModel.mode}-${this.contractModel.userOpenOrders}-${this.contractModel.userQuantity}`;
    },
    nextButtonDisabledExtended() {
      return this.$options.mixins[0].computed.nextButtonDisabled.call(this) || this.isThrottled;
    },
    nextButtonClassModifiers() {
      return {
        'purchase-extended-betslip__button': true,
        'purchase-extended-betslip__button--yes': this.isYesType && !this.nextButtonDisabledExtended,
        'purchase-extended-betslip__button--no': !this.isYesType && !this.nextButtonDisabledExtended,
        'purchase-extended-betslip__button--disabled': this.nextButtonDisabledExtended,
        'purchase-extended-betslip__button--throttled': this.isThrottled,
      };
    },
    skipConfirmationToggleClassModifiers() {
      return {
        'purchase-extended-betslip__skip-confirmation-toggle': true,
        'purchase-extended-betslip__skip-confirmation-toggle--active': this.skipConfirmation,
      };
    },
    buyPrice() {
      return roundToTwo(this.quantity * this.pricePerShare / 100).toFixed(2);
    },
    multiple() {
      const result = 100 / this.pricePerShare
      const rounded = Math.round(result * 100) / 100
      return rounded % 1 === 0 ? Math.round(rounded) : rounded;
    },
    payoutDisplay() {
      if (!this.quantity) {
        return '$-';
      }
      if (this.showSellWarning) {
        return '$-';
      }
      if (this.tradeOptions.operationType === 'sell') {
        const price = this.quantity * this.pricePerShare;
        if (price < 100) {
          return `${price}¢+`;
        }
        return `$${roundToTwo(this.quantity * this.pricePerShare / 100).toFixed(2)}+`;
      }
      return `$${this.quantity}`;
    },
    payoutDisplayTitle() {
      if (this.tradeOptions.operationType === 'sell') {
        return 'This is the estimated payout if your order is matched at the minimum sell price. Actual figures may differ if your order is matched at more favorable prices';
      }

      return '';
    }
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onClickNext() {
      // necessary as we use pointerdown events
      if (this.submitDisabledBecauseOfSwitch) return;
      if (this.skipConfirmation) {
        this.isThrottled = true;
        setTimeout(() => {
          this.isThrottled = false;
        }, 3000);
      }
      this.$emit('submit');
    },
    payoutClick() {
      if (this.tradeOptions.operationType === 'sell') {
        this.setCurrentSmallPopup(MODALS.SMALL_PAYOUT_INFO);
      }
    },
    onQuantityInputBlur(v) {
      if (v === null || v === '') {
        this.setDefaultQuantity();
      }
    },
    onPriceInputBlur(v) {
      if (!v) {
        this.setDefaultPrice();
      }
    },
    onClickOutside() {
      this.inputSelected = null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-extended-betslip/purchase-extended-betslip.js